export default __webpack_public_path__ + "static/3-2c27b13519ae475f0f1db6877f44d26d.png";